<template>
  <v-navigation-drawer
    clipped
    app
    :expand-on-hover="!drawer"
    v-model="drawer"
    :permanent="$vuetify.breakpoint.lgAndUp"
    @transitionend="temp = !temp"
  >
    <v-list dense>
      <template v-for="item in menu">
        <!--Шапка -->
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <v-subheader v-if="item.heading && (drawer || temp)">{{ item.heading }}</v-subheader>
          </v-col>
          <!-- <v-col cols="6" class="text-center">
            <a href="#!" class="body-2">Редактировать</a>
          </v-col> -->
        </v-row>

        <!--Меню -->
        <v-list-group
          v-else-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.model ? item.icon : item['icon-alt']"
          append-icon
          no-action
        >
          <!--Раскрыватель -->
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ stringValues[`${item.text}`][currentLanguage.language] }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <!--Раскрывающиеся списки -->
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            link
            :to="child.link"
          >
            <!-- <template> -->
              <v-list-item-content>
              <v-list-item-title>
                <v-icon left color="primary">{{ child.icon }}</v-icon>
                {{ stringValues[`${child.text}`][currentLanguage.language] }}
              </v-list-item-title>
            </v-list-item-content>
            <!-- <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>-->
            <!-- </template> -->
          </v-list-item>
        </v-list-group>

        <!--Не раскрывающиеся списки -->
        <v-list-item v-else :key="item.text" link :to="item.link">
          <v-list-item-action>
            <v-badge
              v-if="item.badge"
              :content="item.badge"
              :value="item.badge"
              overlap
            ></v-badge>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ stringValues[`${item.text}`][currentLanguage.language] }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <template v-slot:append>
      <template v-if="!drawer && !temp && orderRoute">
        <span class="mx-3">БИН</span> 
      </template>
      <OrderNavigation v-else-if="orderRoute"></OrderNavigation>
      <!-- <v-divider class="mb-2"></v-divider>
      <v-row align="center" justify="center">
        <div class="mx-4">
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon>mdi-tag-outline</v-icon>
                <template v-if="drawer || temp">v1.0.0</template>
              </v-btn>
            </template>

            <v-card class="mx-auto" max-width="300" tile>
              <v-list dense>
                <v-list-item-group>
                  <v-subheader>Документации</v-subheader>
                  <v-list-item
                    v-for="(documentation, i) in documentations"
                    :key="i.title"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="documentation.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="documentation.title"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="documentation.subtitle"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider inset></v-divider>
                  <v-subheader>Версии</v-subheader>
                  <v-list-item v-for="(release, i) in releases" :key="i.title">
                    <v-list-item-icon>
                      <v-icon v-text="release.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="release.title"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-text="release.subtitle"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-spacer></v-spacer>
        </div>
        <div class="mx-4">
          <v-btn @click="$vuetify.theme.dark = !$vuetify.theme.dark" text fab>
            <v-icon v-if="$vuetify.theme.dark">mdi-brightness-4</v-icon>
            <v-icon v-else>mdi-brightness-5</v-icon>
          </v-btn>
        </div>
      </v-row> -->
    </template>
  </v-navigation-drawer>
</template>
<script>
import { menuConfig } from '../../config/menu/menuConfig';

export default {
  name: "Navigation",
  props: {},
  data() {
    return {
      temp: false,
      dialog: false,
      expandFlag: true,
      timerInterval: "",
      menuFor: JSON.parse(JSON.stringify(menuConfig)),
      documentations: [
        {
          icon: "mdi-view-module",
          title: "Текущая версия",
          subtitle: "v2.0.0",
          link: "/",
        },
        {
          icon: "mdi-view-module",
          title: "Стабильная версия",
          subtitle: "v1.0.0",
          link: "/",
        },
      ],

      releases: [
        {
          icon: "mdi-view-module",
          title: "Текущая версия",
          subtitle: "v2.0.0",
          link: "/",
        },
      ],
    };
  },
  computed: {
    drawer: {
      get: function () {
        return this.$store.state.navDrawer;
      },
      set: function (newValue) {
        this.$store.state.navDrawer = newValue;
      },
    },
    userModules: {
      get: function () {
        return this.$store.getters.CURRENT_USER_MODULES;
      },
    },
    orderRoute() {
      if (this.$route.path == "/Order") {
        return true;
      } else {
        return false;
      }
    },
    countUnreadMessages: {
      get: function () {
        window.console.log('COUNT_UNREAD_MESSAGES', this.$store.getters.COUNT_UNREAD_MESSAGES);
        return this.$store.getters.COUNT_UNREAD_MESSAGES;
      },
    },
    menu: {
      get: function () {
        const roleName = this.getRoleName(this.$store.getters.USER.userRoleId);
        let menuFor = this.menuFor[roleName] || [];

        const chatItem = menuFor.find((x) => x.id === "chat");
        if (chatItem) {
            chatItem.badge = this.$store.getters.COUNT_UNREAD_MESSAGES;
        }
        return menuFor || [];
        
      },
    },
    stringValues: {
      get() {
        return this.$store.getters.STRING_VALUES;
      },
    },
    currentLanguage: {
      get() {
        return this.$store.getters.CURRENT_LANG;
      }
    }
  },
  methods: {
     getRoleName(id) {
      const map = {
        1: 'Programmer',
        2: 'Pharmacy',
        10: 'Pharmacy_center',
        11: 'Pharmacy',
        3: 'Pharmacy_administrator',
        4: 'Filial',
        5: 'Filial_administrator',
        6: 'Producer',
        7: 'Producer_administrator',
        8: 'Manager',
        9: 'Accountant',
        12: 'Regional_partner'
      };
      return map[id] || '';
    },
    ChangeTitle(newCount) {
      const self = this;
      self.timerInterval = setInterval(function () {
        if (document.hasFocus()) {
          document.title = "Pharmcenter.kz";
          clearInterval(self.timerInterval);
        } else {
          document.title =
            document.title == "Pharmcenter.kz"
              ? newCount + " сообщение"
              : "Pharmcenter.kz";
        }
      }, 1000);
    },
  },
  created() {},
  watch: {
    countUnreadMessages(newCount) {
      this.menu.find((x) => x.id == "chat").badge = newCount;

      clearInterval(this.timerInterval);
      if (!document.hasFocus()) this.ChangeTitle(newCount);
    },
  },
};
</script>
